<template>
  <v-container>

    <v-card class="my-3">
      <v-card-title>
        AFIP Server Status
      </v-card-title>
      <v-card-text>
        {{serverStatus}}
      </v-card-text>
    </v-card>

    <v-card class="my-3">
      <v-card-title>
        Puntos de venta
      </v-card-title>
      <v-card-text>
        <v-data-table
            v-if="puntosVenta"
            :items="puntosVenta"
            :headers="[
            {text: 'Nro', value: 'Nro'},
            {text: 'EmisionTipo', value: 'EmisionTipo'},
            {text: 'Bloqueado', value: 'Bloqueado'},
            {text: 'FchBaja', value: 'FchBaja'},
        ]"
        ></v-data-table>
      </v-card-text>
    </v-card>

    <v-card class="my-3">
      <v-card-title>
        Tipos de Conceptos
      </v-card-title>
      <v-card-text>
        <v-data-table
            v-if="tipoConceptos"
            :items="tipoConceptos"
            :headers="[
            {text: 'Id', value: 'Id'},
            {text: 'Desc', value: 'Desc'},
            {text: 'FchDesde', value: 'FchDesde'},
            {text: 'FchHasta', value: 'FchHasta'},
        ]"
        ></v-data-table>
      </v-card-text>
    </v-card>

    <v-card class="my-3">
      <v-card-title>
        Tipos de Comprobante
      </v-card-title>
      <v-card-text>
        <v-data-table
            v-if="tiposComprobantes"
            :items="tiposComprobantes"
            :items-per-page="5"
            :headers="[
            {text: 'Id', value: 'Id'},
            {text: 'Desc', value: 'Desc'},
            {text: 'FchDesde', value: 'FchDesde'},
            {text: 'FchHasta', value: 'FchHasta'},
        ]"
        ></v-data-table>
      </v-card-text>
    </v-card>


    <v-card class="my-3">
      <v-card-title>
        Tipos de Documento
      </v-card-title>
      <v-card-text>
        <v-data-table
            v-if="tipoDocumentos"
            :items="tipoDocumentos"
            :items-per-page="5"
            :headers="[
            {text: 'Id', value: 'Id'},
            {text: 'Desc', value: 'Desc'},
            {text: 'FchDesde', value: 'FchDesde'},
            {text: 'FchHasta', value: 'FchHasta'},
        ]"
        ></v-data-table>
      </v-card-text>
    </v-card>

    <v-card class="my-3">
      <v-card-title>
        Tipos de Alicuotas
      </v-card-title>
      <v-card-text>
        <v-data-table
            v-if="tipoAlicuotas"
            :items="tipoAlicuotas"
            :items-per-page="5"
            :headers="[
            {text: 'Id', value: 'Id'},
            {text: 'Desc', value: 'Desc'},
            {text: 'FchDesde', value: 'FchDesde'},
            {text: 'FchHasta', value: 'FchHasta'},
        ]"
        ></v-data-table>
      </v-card-text>
    </v-card>

    <v-card class="my-3">
      <v-card-title>
        Tipos de Monedas
      </v-card-title>
      <v-card-text>
        <v-data-table
            v-if="tipoMonedas"
            :items="tipoMonedas"
            :items-per-page="5"
            :headers="[
            {text: 'Id', value: 'Id'},
            {text: 'Desc', value: 'Desc'},
            {text: 'FchDesde', value: 'FchDesde'},
            {text: 'FchHasta', value: 'FchHasta'},
        ]"
        ></v-data-table>
      </v-card-text>
    </v-card>

  </v-container>
</template>

<script>
import AfipMixin from "@/modules/afip/mixins/AfipMixin";

export default {
  name: "AfipTiposPage",
  mixins: [AfipMixin],
  async created() {
    await this.getServerStatus()
    await this.getTipoComprobantes()
    await this.getTipoConceptos()
    await this.getTipoDocumentos()
    await this.getTipoAlicuotas()
    await this.getPuntosVenta()
    await this.getTipoMonedas()
  },

}
</script>

<style scoped>

</style>
